/** Id of the copy of the widget that is printed; the print styles hide everything else on the page. */
export const PRINT_ROOT_ID = 'widget-print-root';
/** Set on the body while a widget is printed; the print styles key off it. */
export const PRINTING_ATTRIBUTE = 'data-printing-widget';

function clearPrintCopy(): void {
  document.getElementById(PRINT_ROOT_ID)?.remove();
  document.body.removeAttribute(PRINTING_ATTRIBUTE);
}

/**
 * Print one element alone. A copy of it is put in its own root on the body and the print styles hide every other
 * child of the body, so the sidebar, the other widgets and the controls are not printed. The page is put back as
 * soon as printing is over, or at once if the browser cannot print.
 * @param element - What to print
 */
export function printElement(element: HTMLElement): void {
  clearPrintCopy();

  const root = document.createElement('div');
  root.id = PRINT_ROOT_ID;
  root.appendChild(element.cloneNode(true));
  document.body.appendChild(root);
  document.body.setAttribute(PRINTING_ATTRIBUTE, '');

  const restore = () => {
    clearPrintCopy();
    window.removeEventListener('afterprint', restore);
  };
  window.addEventListener('afterprint', restore);

  try {
    window.print();
  } catch (error) {
    restore();
    throw error;
  }
}
